import { Component, Input, OnInit } from '@angular/core';
import TabBase from '../tab-base';
import { NbWindowRef, NbWindowService } from '@nebular/theme';
import { TeamPlayersModalComponent } from '@theme/components';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-tab-enrollments',
    templateUrl: './enrollments.component.html',
    styleUrls: ['./enrollments.component.scss'],
})
export class TabEnrollmentsComponent extends TabBase implements OnInit {
    /**
     * Parametros para listagem da classificação
     * @property { string } tournamentId - id do torneio
     * @property { categoryId } categoryId; - id da categoria
     */
    @Input() tournamentId: string;
    @Input() categoryId: string;

    enrollments: any;

    isTeam: boolean = false;
    window: NbWindowRef;
    /* Paginação */
    perPage: number = 8;
    page: number = 1;

    constructor(private nbWindowService: NbWindowService, private translate: TranslateService) {
        super();
    }

    ngOnInit(): void {
        this.getEnrollments();
    }

    private getEnrollments() {
        this.tournamentService.getEnrollments(this.tournamentId, this.categoryId).subscribe((response) => {
            this.enrollments = response.registers;
            this.isTeam = response.meta.is_team;
        });
    }

    openTeamDetails(equipe: any) {
        this.window = this.nbWindowService.open(TeamPlayersModalComponent, {
            context: {
                equipe,
            },
            windowClass: 'no-extra-buttons',
            title: this.translate.instant('BUTTON.LIST-OF-ATHLETES'),
        });
    }
}
